export const LANDLORD_PORTAL_PATHS = {
  DEFAULT: ":regionId/landlord/:contactId",
  OVERVIEW: "",
  FINANCIALS: "financials",
  MAINTENANCE: "maintenance",
  INSPECTIONS: "inspections",
  INSPECTION_DETAILS: "inspections/:inspectionId",
  DOCUMENTS: "documents",
} as const;
